const jsonSchema = [
  {
        name: 'name',
        label: 'Name',
        type: 'text',
        required: true,
        showInList: true
    },
  {
    type: 'group',
    fields: [
      {
        name: 'startDate',
        label: 'Start Date',
        type: 'date',
        pattern: 'dd/MM/yyyy',
        required: true,
        showInList: true
      },
      {
        name: 'endDate',
        label: 'End Date',
        type: 'date',
        pattern: 'dd/MM/yyyy',
        required: true,
        showInList: true
      }
    ]
  },
  {
    type: 'group',
    fields: [
      {
        name: 'startTime',
        label: 'Start Time',
        type: 'time',
        required: true,
        showInList: false
      },
      {
        name: 'endTime',
        label: 'End Time',
        type: 'time',
        required: true,
        showInList: false
      }
    ]
  },
  ,
  {
    name: 'active',
    label: 'Active',
    type: 'checkbox',
    required: false,
    isChecked: 'on'
  }
  // Add more fields as needed
];
export default jsonSchema;
